{
  "header": {
    "title": "Price Lists",
    "description": "Price lists let you customize your specific B2B pricing.",
    "actions": {
      "create": "Create price list",
      "bulk_upload": "Bulk upload"
    }
  },
  "footer": {
    "description": "Learn more about price lists"
  },
  "empty_state": {
    "title": "Manage your price lists",
    "description": "Set up specific B2B pricing for your products.",
    "create": "Create price list",
    "templates": {
      "description": "Or start with a ready-made price list that you can edit later.",
      "percent_off": "{percent}% off {name}"
    }
  },
  "redirect": {
    "title": "Price lists are now configured in Shopify",
    "description": "Click the button below to configure your SparkLayer price lists in Shopify.",
    "action": "Configure price lists"
  },
  "table": {
    "caption": "Table of all your price lists",
    "headings": {
      "name": "Name",
      "currency": "Currency",
      "type": "Type"
    },
    "row": {
      "handle": "Handle: {handle}"
    }
  },
  "help_cards": {
    "header": "More ways to control your B2B pricing",
    "quantity_pricing": {
      "title": "B2B discounts & promotions",
      "description": "Run targeted promotions for your B2B customers - bulk discounts, customer-specific offers, and more.",
      "action": "Manage discounts"
    },
    "pack_size_rules": {
      "title": "Price editor for quick changes",
      "description": "Edit individual product prices on the fly - perfect for quick tweaks without uploading a CSV.",
      "action": "Go to price editor"
    }
  },
  "resources_card": {
    "header": "Need something more specific? SparkLayer also handles",
    "quantity_pricing": {
      "title": "Quantity pricing",
      "subtitle": "Reward bulk orders with tiered prices."
    },
    "pack_size_rules": {
      "title": "Pack size rules",
      "subtitle": "Sell in cases, boxes, or pallets."
    },
    "unit_of_measure": {
      "title": "Unit of measure pricing",
      "subtitle": "Price by weight, length, or volume"
    }
  },
  "modals": {
    "confirm_delete": {
      "title": "Delete {name}?",
      "body": "Are you sure you want to delete the price list <strong>{name}</strong>? This can't be undone.",
      "delete": "Delete price list"
    },
    "confirm_clear": {
      "title": "Clear {name}?",
      "body": "When you clear price lists, any manually uploaded prices will automatically be removed. Are you sure you want to clear the price list <strong>{name}</strong>? This can't be undone.",
      "clear": "Clear price list"
    },
    "assign_first_price_list": {
      "title": "Let's assign your first price list!",
      "body": "Now you've created your first price list, the next step is to assign your pricing to your B2B customers.<br/><br/>To save time, we can automatically assign this to your default customer group.",
      "later": "I'll do this later",
      "assign": "Assign price list"
    },
    "assign_price_list": {
      "title": "Let's assign a price list!",
      "body": "Now you've created your price lists, the next step is to assign your pricing to your B2B customers.",
      "later": "I'll do this later",
      "assign": "Assign price lists"
    },
    "upgrade_plan": {
      "heading": "Your B2B is outgrowing the basics",
      "body": "You've reached {maxPriceLists} price lists — that's a great sign your wholesale is growing. Upgrade to create tailored pricing for more of your B2B customers and unlock powerful tools to grow your wholesale business.",
      "features_heading": "With our Starter plan you'll get:",
      "features": {
        "unlimited_price_lists": "<strong>Unlimited price lists</strong> — no cap on how many pricing tiers you can create",
        "sales_agent_portal": "<strong>Sales Agent Portal</strong> — your reps get their own login to place orders at customer-specific pricing",
        "orders_per_month": "<strong>50 orders per month</strong> — more room to grow",
        "discount_engine": "<strong>B2B Discount Engine</strong> — flexible discounts built for wholesale",
        "personalised_onboarding": "<strong>Personalised onboarding</strong> — we'll help you get set up"
      },
      "cta": "Upgrade to Starter - {price} / month",
      "compare_plans": "Compare all plans"
    },
    "upload_csv": {
      "title": {
        "single": "Import pricing data by CSV",
        "bulk": "Bulk import pricing data by CSV"
      }
    }
  },
  "notifications": {
    "success": {
      "price_list_assigned_to_base": "We have successfully assigned the price list to your default customer group.",
      "clear_succeeded": "Price list \"{name}\" successfully cleared.",
      "delete_succeeded": "Price list \"{name}\" successfully deleted.",

      "csv_upload_succeeded": {
        "single": "Price list successfully uploaded.",
        "bulk": "Bulk price lists successfully uploaded."
      }
    },
    "errors": {
      "delete_used_by_group": "Price list \"{name}\" cannot be deleted because it's used by one or more customer groups. Please remove the price list from all customer groups before attempting to delete it.",
      "delete_has_child": "Price list \"{name}\" cannot be deleted because it's used as the source for one or more other price lists. Please update any inheriting price lists to use a different source before attempting to delete it.",
      "clear_failed": "Failed to clear price list.",
      "delete_failed": "Failed to delete price list."
    }
  }
}
